<template>
    <b-container fluid class="px-0 demo-body">
        <div id="main-wrapper" class="demo-form bg-white">
            <div class="container-fluid px-0">
                <div class="row g-0 min-vh-100">
                    <!-- Welcome Text
                    ========================= -->
                    <div class="col-md-6 py-0">
                        <div class="hero-wrap d-flex align-items-center h-100">
                            <div class="hero-mask theme-bgg"></div>
                            <div class="hero-bg hero-bg-scroll" style="background-image:url('./images/login-bg.jpg');">
                            </div>
                            <div class="hero-content w-100 min-vh-100 d-flex flex-column">
                                <div class="row g-0">
                                    <div class="col-11 col-sm-11 col-lg-11 mx-auto">
                                        <div class="logo mt-5 mb-5 mb-md-0">
                                            <a class="d-flex" href="/" title="Qapin">
                                                <svg width="106px" height="24px" viewBox="0 0 106 24" version="1.1"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <title>0DDEA7CC-09FA-43D7-91E5-0FB6CE4E5E4E</title>
                                                    <g id="calendar-9Dec2020" stroke="none" stroke-width="1" fill="none"
                                                        fill-rule="evenodd">
                                                        <g id="Header/header" transform="translate(-25.000000, -23.000000)"
                                                            fill="#fff">
                                                            <path
                                                                d="M37.2171088,23 C40.6784385,23 43.5744946,24.1647612 45.9047399,26.4922442 C48.1732115,28.7147603 49.3481642,31.4316658 49.4297823,34.6412076 C49.4346831,34.8394428 49.2718155,35.0020449 49.0733162,35.0020449 L49.0733162,35.0020449 L43.9787986,35.0020449 C43.7939074,35.0020449 43.6317561,34.8510342 43.6242,34.6665013 C43.5543331,32.9586238 42.9458358,31.4993541 41.7983858,30.2895509 C40.5769865,28.9791096 39.049727,28.323084 37.2171088,28.323084 C35.3844905,28.323084 33.8572311,28.9791096 32.6358318,30.2895509 C31.4138953,31.5778468 30.8032135,33.149024 30.8032135,35.0020449 C30.8032135,36.8560677 31.4138953,38.4382996 32.6358318,39.7488125 C33.7821358,40.9579001 35.1978804,41.5998658 36.8825642,41.6742084 C37.0665959,41.6822938 37.2171088,41.8443236 37.2171088,42.0282841 L37.2171088,42.0282841 L37.2171088,46.643825 C37.2171088,46.8419528 37.0543845,47.0045192 36.8561,47 C33.5312811,46.9226278 30.7444838,45.7713542 28.4951351,43.5461191 C26.1648899,41.2181352 25,38.3702536 25,35.0020449 C25,31.6348381 26.1648899,28.7975819 28.4951351,26.4922442 C30.8254162,24.1647612 33.7325736,23 37.2171088,23 Z M65.6810811,23.3393359 C65.8110743,23.3393359 65.9582568,23.4371834 66.00875,23.5567828 L66.00875,23.5567828 L75.4832162,46.0364191 C75.5974527,46.3076731 75.4499122,46.5296278 75.1551892,46.5296278 L75.1551892,46.5296278 L69.82475,46.5296278 C69.6915338,46.5296278 69.5425608,46.4282385 69.4938581,46.304346 L69.4938581,46.304346 L68.0213176,42.5628857 L58.2475088,42.5628857 L56.80795,46.3018416 C56.7597128,46.4271294 56.6103459,46.5296278 56.4760196,46.5296278 L56.4760196,46.5296278 L51.1480514,46.5296278 C50.8530777,46.5296278 50.7056446,46.30753 50.8204541,46.0360255 L50.8204541,46.0360255 L60.3275081,23.5563535 C60.3780014,23.4370046 60.5254345,23.3393359 60.6551412,23.3393359 L60.6551412,23.3393359 Z M87.1478716,23.474963 C90.1796149,23.474963 92.5549459,24.2323064 94.2749392,25.7465281 C96.0393378,27.2612148 96.9217162,29.3179089 96.9217162,31.9172185 C96.9217162,34.6072561 96.0056757,36.7431584 94.1732365,38.3248895 C92.3404392,39.8844395 89.8512297,40.663964 86.7066824,40.663964 L86.7066824,40.663964 L83.5846959,40.663964 L83.5846959,46.1743 C83.5846959,46.3697446 83.4246216,46.5296278 83.2290946,46.5296278 L83.2290946,46.5296278 L78.2048378,46.5296278 C78.0089527,46.5296278 77.8492365,46.3697446 77.8492365,46.1743 L77.8492365,46.1743 L77.8492365,23.8302908 C77.8492365,23.6348819 78.0089527,23.474963 78.2048378,23.474963 L78.2048378,23.474963 Z M105.023196,23.474963 C105.218723,23.474963 105.378797,23.6348819 105.378797,23.8302908 L105.378797,23.8302908 L105.378797,46.1743 C105.378797,46.3697446 105.218723,46.5296278 105.023196,46.5296278 L105.023196,46.5296278 L99.9989392,46.5296278 C99.8030541,46.5296278 99.6433378,46.3697446 99.6433378,46.1743 L99.6433378,46.1743 L99.6433378,23.8302908 C99.6433378,23.6348819 99.8030541,23.474963 99.9989392,23.474963 L99.9989392,23.474963 Z M114.003473,23.474963 C114.093716,23.474963 114.215115,23.5308452 114.273845,23.5991774 L114.273845,23.5991774 L125.298561,36.4602413 L125.298561,23.8302908 C125.298561,23.6348819 125.458635,23.474963 125.65452,23.474963 L125.65452,23.474963 L130.644399,23.474963 C130.839926,23.474963 131,23.6348819 131,23.8302908 L131,23.8302908 L131,46.1743 C131,46.3697446 130.839926,46.5296278 130.644399,46.5296278 L130.644399,46.5296278 L126.749973,46.5296278 C126.660804,46.5296278 126.54048,46.4749262 126.482108,46.4081323 L126.482108,46.4081323 L115.525074,33.8831845 L115.525074,46.1743 C115.525074,46.3697446 115.365,46.5296278 115.169473,46.5296278 L115.169473,46.5296278 L110.144858,46.5296278 C109.949331,46.5296278 109.789257,46.3697446 109.789257,46.1743 L109.789257,46.1743 L109.789257,23.8302908 C109.789257,23.6348819 109.949331,23.474963 110.144858,23.474963 L110.144858,23.474963 Z M40.9961878,37.3183301 C41.0893676,37.2235593 41.2658074,37.1883557 41.3882804,37.2400521 L41.3882804,37.2400521 L47.9629304,40.0156303 C48.1582784,40.0980941 48.2363101,40.3184031 48.1404804,40.5073722 C47.5850905,41.6023701 46.8356419,42.6135446 45.8997622,43.5484804 C44.9502385,44.4876735 43.8896297,45.2389349 42.7488764,45.7945013 C42.5615142,45.8857303 42.3433547,45.8075596 42.2616345,45.615943 L42.2616345,45.615943 L39.5021966,39.1514596 C39.4506291,39.0310374 39.4836108,38.8560925 39.5755014,38.7626812 L39.5755014,38.7626812 Z M63.1342162,30.0182968 L60.1477736,37.6804912 L66.1211959,37.6804912 L63.1342162,30.0182968 Z M87.0458108,28.5267929 L83.5846959,28.5267929 L83.5846959,35.6464433 L87.0458108,35.6464433 C88.3127973,35.6464433 89.3251689,35.3076083 90.0832838,34.6294373 C90.8413986,33.9512663 91.2206351,33.0476704 91.2206351,31.9172185 C91.2206351,30.8774947 90.8413986,30.0520694 90.0832838,29.4419803 C89.3251689,28.8318554 88.3127973,28.5267929 87.0458108,28.5267929 L87.0458108,28.5267929 Z"
                                                                id="Combined-Shape"></path>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row g-0 my-auto">
                                    <div class="col-11 col-sm-11 col-lg-11 mx-auto">
                                        <h1 class="text-11 text-white mb-4 fw-600 pl-150">Search, onboard and Pay your
                                            global engineering team compliantly</h1>
                                        <p class="text-4 text-white lh-base mb-3 pl-150">All-in-one platform to hire Source
                                            Inspectors from anywhere in the world with one click</p>
                                        <img src="web/dashboard-demo.png" class="img-fluid w-100 pl-150">
                                        <p class="companies-title desktop text-center text-white fw-600 fz-18 pl-150">Work
                                            with Internationally recognized Talent from anywhere</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Welcome Text End -->

                    <!-- Login Form
                    ========================= -->
                    <div class="col-md-6">
                        <div class="my-auto py-3">
                            <div class="row g-0">
                                <div class="col-11 col-sm-10 col-lg-10 col-xl-10 mx-auto">
                                    <h1 class="text-11 fw-600 mb-0 text-center text-theme">Get started with Qapin</h1>
                                    <p class="text-center fz-20 text-theme fw-400">Schedule a 30-minute product demo with
                                        expert Q&A</p>
                                    <form id="loginForm" @submit.prevent="demoSubmit" method="post">
                                        <b-row>
                                            <b-col xl="6" lg="6" sm="12">
                                                <b-form-group class="mb-0 pos-rel">
                                                    <label class="form-label fz-16">First name</label>
                                                    <!-- <input type="email" class="form-control" required="" placeholder="First name"> -->
                                                    <b-form-input type="text" placeholder="First name"
                                                        v-model="demo.first_name" class="form-control"
                                                        @input="$v.demo.first_name.$touch()"
                                                        @blur="$v.demo.first_name.$touch()"
                                                        :class="{ 'is-invalid': $v.demo.first_name.$error }"
                                                        :error-messages="FirstNameError">
                                                    </b-form-input>
                                                    <p class="text-danger pos-absolute" v-if="FirstNameError[0]">{{ FirstNameError[0] }}
                                                    </p>
                                                </b-form-group>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="12">
                                                <b-form-group class="mb-0 pos-rel">
                                                    <label class="form-label fz-16">Last name</label>
                                                    <!-- <input type="email" class="form-control" required=""
                                                        placeholder="Last name"> -->
                                                        <b-form-input type="text" placeholder="Last name"
                                                        v-model="demo.last_name" class="form-control"
                                                        @input="$v.demo.last_name.$touch()"
                                                        @blur="$v.demo.last_name.$touch()"
                                                        :class="{ 'is-invalid': $v.demo.last_name.$error }"
                                                        :error-messages="LastNameError">
                                                    </b-form-input>
                                                    <p class="text-danger pos-absolute" v-if="LastNameError[0]">{{ LastNameError[0] }}
                                                    </p>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col xl="6" lg="6" sm="12">
                                                <b-form-group class="mb-0 pos-rel">
                                                    <label class="form-label fz-16">Work Email</label>
                                                    <!-- <input type="email" class="form-control" required=""
                                                        placeholder="Enter Your Email"> -->
                                                        <b-form-input id="email" type="text" placeholder="Enter Your Email"
                                                        v-model="demo.email" name="email" class="form-control"   @input="$v.demo.email.$touch()"
                                                        @blur="$v.demo.email.$touch()"
                                                        :class="{ 'is-invalid': $v.demo.email.$error }"></b-form-input>
                            
                                                    <span class="text-danger pos-absolute" v-if="!$v.demo.email.required && $v.demo.$error">Work Email is
                                                        required</span>
                                                    <span class="text-danger pos-absolute" v-if="!$v.demo.email.email">Work Email is invalid</span>
                                                    <!-- <span class="text-danger" v-if="!$v.demo.email.emailvalidate">Work Email is invalid</span> -->
                                                </b-form-group>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="12">
                                                <b-form-group class="mb-0 pos-rel">
                                                    <label class="form-label fz-16">Company Size</label>
                                                    <b-form-select class="form-control" v-model="demo.company_size">
                                                        <!-- <template slot="first">
                                                            <option :value="null" disabled>-- Select State --</option>
                                                            </template> -->
                                                        <option :value="null" disabled>-- Select an option --</option>
                                                        <option value="1-50">1-50</option>
                                                        <option value="51-100">51-100</option>
                                                        <option value="101-150">101-150</option>
                                                        <option value="151-200">151-200</option>
                                                        <option value="200+">200+</option>
                                                    </b-form-select>
                                                    <!-- <select class="form-control">
                                                        <option>Select an option</option>
                                                        <option>1-50</option>
                                                        <option>51-100</option>
                                                        <option>101-150</option>
                                                        <option>151-200</option>
                                                    </select> -->
                                                    <span class="text-danger pos-absolute" v-if="!$v.demo.company_size.required && $v.demo.company_size.$dirty">Company size 
                                                is required</span>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col xl="6" lg="6" sm="12">
                                                <b-form-group class="mb-0 pos-rel">
                                                    <label class="form-label fz-16">Company Website</label>
                                                    <!-- <input type="email" class="form-control" 
                                                        placeholder="Company website"> -->
                                                        <b-form-input type="text" placeholder="Company website"
                                                        v-model="demo.company_website" class="form-control"
                                                        @input="$v.demo.company_website.$touch()"
                                                        @blur="$v.demo.company_website.$touch()"
                                                        :class="{ 'is-invalid': $v.demo.company_website.$error }"
                                                        :error-messages="CompanyWebsiteError">
                                                    </b-form-input>
                                                    <p class="text-danger" v-if="!isValidHttpUrl() && demo.company_website!=''">Company website should be valid.</p>
                                                    <p class="text-danger  pos-absolute" v-if="CompanyWebsiteError[0]">{{ CompanyWebsiteError[0] }}
                                                    </p>
                                                </b-form-group>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="12">
                                                <!-- <b-form-group class="mb-0 pos-rel">
                                                    <label class="form-label fz-16">Phone Number</label>
                                                        <b-form-input type="text" placeholder="Phone Number"
                                                        v-model="demo.telephone" class="form-control"
                                                        @input="$v.demo.telephone.$touch()"
                                                        @blur="$v.demo.telephone.$touch()"
                                                        :class="{ 'is-invalid': $v.demo.telephone.$error }"
                                                        :error-messages="Telephone">
                                                    </b-form-input>
                                                    <p class="text-danger pos-absolute" v-if="Telephone[0]">{{ Telephone[0] }}
                                                    </p>
                                                </b-form-group> -->
                                                <b-form-group class="mb-0 pos-rel">
                                                    <label class="form-label fz-16">Phone Number</label>
                                                    <vue-tel-input
                                                        v-bind="bindProps"
                                                        v-model="phone"
                                                        :country="phone_code"
                                                        @country-changed="countryChanges"
                                                        class="form-control d-flex align-items-center"
                                                        @input="$v.phone.$touch()"
                                                        @blur="$v.phone.$touch()"
                                                        :class="{ 'is-invalid': Phonemessage }"
                                                        :error-messages="Phonemessage">
                                                    ></vue-tel-input>
                                                    <!-- <p class="text-danger pos-absolute" v-if="Telephone[0]">{{ Telephone[0] }}
                                                    </p> -->
                                                    <p class="text-danger" v-if="phone=='+'+phone_code">{{Phonemessage}}</p>
                                                    <p class="text-danger" v-if="PhoneErrors[0]">{{PhoneErrors[0]}}</p>
                                                </b-form-group>

                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col xl="12" lg="12" sm="12">
                                                <b-form-group class="mb-0 pos-rel">
                                                    <label class="form-label fz-16">Company Headquarters</label>
                                                    <b-form-select 
                                                        v-model="demo.headQuarter"
                                                        :options="country"
                                                        value-field="country_id"
                                                        text-field="country_name"
                                                        class="form-control"></b-form-select>
                                                        <!-- <span v-if="!$v.profile.country_id.required && $v.profile.country_id.$error" class="error-msg">Country is required</span> -->
                                                        
                                                    <!-- <b-form-select class="form-control" v-model="demo.headQuarter">
                                                        <option value="">Select an option</option>
                                                        <option value="India">India</option>
                                                    </b-form-select>-->
                                                    <p class="text-danger" v-if="HeadQuarterError[0]">{{ HeadQuarterError[0] }}
                                                    </p>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col xl="12" lg="12" sm="12">
                                                <div class="privacy-field text-center mt-3">
                                                    <p class="mb-0 text-muted fz-12">We respect your data. By submitting this
                                                        form, you agree that we will contact you in relation <br> to our
                                                        products and services, in accordance with our <a
                                                            href="javascript:void(0);" rel="noreferrer"
                                                            class="text-theme" @click="$router.push('/privacy-policy').catch(()=>{})"><span>Privacy policy</span></a>.</p>
                                                    <span class="text-muted fz-12">Contractor or employee? <a
                                                            href="javascript:void(0);"  rel="noreferrer"
                                                            class="text-theme" @click="$router.push('/sign-up').catch(()=>{})">Sign up here</a> instead.</span>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col xl="12" lg="12" sm="12">
                                                <div class="d-grid my-2 m-auto">
                                                    <button class="btn btn-theme btn-lg m-auto fz-22" type="submit">Book a demo</button>
                                                </div>
                                                <!-- <b-modal id="modal-demo" centered title="" hide-header hide-footer>
                                                    <div class="days-chooser-holder text-center">
                                                        <h6 class="fz-16 fw-600 text-black">Thanks! What time works best for
                                                            a quick call?</h6>
                                                        <div class="scheduler-wrapper">
                                                            <div class="fabe-arrow-holder fabe-left">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16"
                                                                    height="16" fill="currentColor"
                                                                    class="bi bi-chevron-left" viewBox="0 0 16 16">
                                                                    <path fill-rule="evenodd"
                                                                        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                                                                </svg>
                                                            </div>
                                                            <div class="inner-wrapper">
                                                                <div class="header fw-600 fz-14">
                                                                    Sun
                                                                </div>
                                                                <div class="content-body fz-14">
                                                                    18 <br> Feb
                                                                </div>
                                                            </div>
                                                            <div class="inner-wrapper">
                                                                <div class="header fw-600 fz-14">
                                                                    Mon
                                                                </div>
                                                                <div class="content-body fz-14">
                                                                    19 <br> Feb
                                                                </div>
                                                            </div>
                                                            <div class="inner-wrapper">
                                                                <div class="header fw-600 fz-14">
                                                                    Tues
                                                                </div>
                                                                <div class="content-body fz-14">
                                                                    20 <br> Feb
                                                                </div>
                                                            </div>
                                                            <div class="inner-wrapper">
                                                                <div class="header fw-600 fz-14">
                                                                    Wed
                                                                </div>
                                                                <div class="content-body fz-14">
                                                                    21 <br> Feb
                                                                </div>
                                                            </div>
                                                            <div class="inner-wrapper">
                                                                <div class="header fw-600 fz-14">
                                                                    Thu
                                                                </div>
                                                                <div class="content-body fz-14">
                                                                    22 <br> Feb
                                                                </div>
                                                            </div>
                                                            <div class="inner-wrapper">
                                                                <div class="header fw-600 fz-14">
                                                                    Fri
                                                                </div>
                                                                <div class="content-body fz-14">
                                                                    23 <br> Feb
                                                                </div>
                                                            </div>
                                                            <div class="inner-wrapper">
                                                                <div class="header fw-600 fz-14">
                                                                    Sat
                                                                </div>
                                                                <div class="content-body fz-14">
                                                                    24 <br> Feb
                                                                </div>
                                                            </div>
                                                            <div class="fabe-arrow-holder fabe-right">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16"
                                                                    height="16" fill="currentColor"
                                                                    class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                                    <path fill-rule="evenodd"
                                                                        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                                                </svg>
                                                            </div>
                                                        </div>

                                                        <h5 class="fz-18 fw-600 text-black mt-5">What time works?</h5>
                                                        <h6 class="fz-16 fw-400 text-muted">15 minute meeting -
                                                            Asia/Calcutta Time (10:19 AM)</h6>
                                                        <b-row class="time-wrapper">
                                                            <b-col xl="4" lg="4" sm="12" class="cat action">
                                                                <label>
                                                                    <input type="radio" name="radio"><span>1:30 PM</span>
                                                                </label>
                                                            </b-col>

                                                            <b-col xl="4" lg="4" sm="12" class="cat">
                                                                <label>
                                                                    <input type="radio" name="radio"><span>1:45 PM</span>
                                                                </label>
                                                            </b-col>

                                                            <b-col xl="4" lg="4" sm="12" class="cat">
                                                                <label>
                                                                    <input type="radio" name="radio"><span>2:00 PM</span>
                                                                </label>
                                                            </b-col>

                                                            <b-col xl="4" lg="4" sm="12" class="cat">
                                                                <label>
                                                                    <input type="radio" name="radio"><span>2:15 PM</span>
                                                                </label>
                                                            </b-col>

                                                            <b-col xl="4" lg="4" sm="12" class="cat">
                                                                <label>
                                                                    <input type="radio" name="radio"><span>2:30 PM</span>
                                                                </label>
                                                            </b-col>

                                                            <b-col xl="4" lg="4" sm="12" class="cat">
                                                                <label>
                                                                    <input type="radio" name="radio"><span>2:45 PM</span>
                                                                </label>
                                                            </b-col>

                                                            <b-col xl="4" lg="4" sm="12" class="cat">
                                                                <label>
                                                                    <input type="radio" name="radio"><span>3:00 PM</span>
                                                                </label>
                                                            </b-col>

                                                            <b-col xl="4" lg="4" sm="12" class="cat">
                                                                <label>
                                                                    <input type="radio" name="radio"><span>3:15 PM</span>
                                                                </label>
                                                            </b-col>

                                                            <b-col xl="4" lg="4" sm="12" class="cat">
                                                                <label>
                                                                    <input type="radio" name="radio"><span>3:30 PM</span>
                                                                </label>
                                                            </b-col>

                                                            <b-col xl="4" lg="4" sm="12" class="cat">
                                                                <label>
                                                                    <input type="radio" name="radio"><span>3:45 PM</span>
                                                                </label>
                                                            </b-col>

                                                            <b-col xl="4" lg="4" sm="12" class="cat">
                                                                <label>
                                                                    <input type="radio" name="radio"><span>4:00</span>
                                                                </label>
                                                            </b-col>

                                                            <b-col xl="4" lg="4" sm="12" class="cat sports">
                                                                <label>
                                                                    <input type="radio" name="radio"><span>4:15 PM</span>
                                                                </label>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row>
                                                            <b-col xl="4" lg="4" sm="12">
                                                                <button class="btn btn-theme w-100"
                                                                    v-b-modal.modal-demo-successful>Continue</button>
                                                            </b-col>
                                                        </b-row>
                                                    </div>
                                                </b-modal> -->
                                               
                                            </b-col>
                                        </b-row>
                                    </form>
                                    <b-modal id="modal-demo-successful" centered title="" hide-header
                                        hide-footer>
                                        <div class="days-chooser-holder text-center">
                                            <h6 class="fz-16 fw-600 text-black">Thanks You! </h6>
                                            <h6 class="fz-16 fw-600 text-black">Your demo request sent successfully and the Qapin representative will contact you within 24 hours.</h6>
                                        </div>
                                    </b-modal>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Login Form End -->
                </div>
            </div>
        </div>
    </b-container>
</template>
<script type="module">
import axios from "axios";
import $ from 'jquery';
/*import 'slick-carousel/slick/slick.css';*/
import 'slick-carousel';
import Vue from 'vue';
import { mapActions } from 'vuex'
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);
import { helpers } from 'vuelidate/lib/validators'

//const emailvalidate = helpers.regex('emailvalidate', /^\w+([/.-]?\w+)*@\w+([/.-]?\w+)*(\w{2,3})+$/);
const namevalidate = helpers.regex('namevalidate', /^[a-zA-Z ]*$/);
//const mobilevalidate = helpers.regex('mobilevalidate', /^[789]\d{9}$/);
// /const urlvalidate = isValidHttpUrl();//helpers.regex('urlvalidate', '/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g');
import { required, email, minLength, maxLength } from "vuelidate/lib/validators";
export default {
    components: {},

    data() {
        return {
            demo: {
                first_name: '',
                last_name: '',
                email: '',
                company_size: null,
                company_website: '',
                telephone: '',
                headQuarter: '',
                // phone:'',
                // phone_code:'',
                
            },
            phone:'',
            phone_code:'',
            country:[],
            bindProps               : {
                mode                    : "international",
                placeholder             : "Enter a phone number",
                required                : true,
                enabledCountryCode      : true,
                enabledFlags            : true,
                autocomplete            : "off",
                name                    : "telephone",
                maxlength                   : 15,
                inputOptions            : {
                    showDialCode            : true
                },
                validCharactersOnly     : true,
            },
            Phonemessage:'',
        };
    },
    validations: {
        demo: {
            email: { required, email },
            first_name: { required, namevalidate, minLength: minLength(3), maxLength: maxLength(50) },
            last_name: { required, namevalidate, minLength: minLength(3), maxLength: maxLength(50) },
          //  telephone: { required, minLength: minLength(9), maxLength: maxLength(15) },
           // phone : { required, minLength: minLength(9), maxLength: maxLength(15) },
            company_size: { required },
            company_website: { required },
            headQuarter: { required },

        },
        phone : { required, minLength: minLength(9), maxLength: maxLength(15) },
    },
    computed: {
        FirstNameError() {
            const errors = []
            if (!this.$v.demo.first_name.$dirty) return errors
            !this.$v.demo.first_name.required && errors.push('First Name is required');
            !this.$v.demo.first_name.namevalidate && errors.push(' Only character is allowed');
            !this.$v.demo.first_name.maxLength && errors.push("Maximum 50 characters allow.");
            !this.$v.demo.first_name.minLength && errors.push("Minimum 3 characters allow.");
            return errors
        },
        LastNameError() {
            const errors = []
            if (!this.$v.demo.last_name.$dirty) return errors
            !this.$v.demo.last_name.required && errors.push('Last Name is required');
            !this.$v.demo.last_name.namevalidate && errors.push(' Only character is allowed');
            !this.$v.demo.last_name.maxLength && errors.push("Maximum 50 characters allow.");
            !this.$v.demo.last_name.minLength && errors.push("Minimum 3 characters allow.");
            return errors
        },

        // Telephone() {
        //     const errors = []
        //     if (!this.$v.demo.telephone.$dirty) return errors
        //     !this.$v.demo.telephone.required && errors.push('Phone number is required');
        //     //!this.$v.demo.telephone.mobilevalidate && errors.push('Phone number should be valid.');
        //     !this.$v.demo.telephone.minLength && errors.push("Minimum 9 and Maximum 15 digit should be allowed 9 in phone number field.");
        //     !this.$v.demo.telephone.maxLength && errors.push("Minimum 9 and Maximum 15 digit should be allowed in phone number field.");

        //     return errors
        // },
        PhoneErrors() {
        const errors = [];
        if (!this.$v.phone.$dirty) return errors;
        !this.$v.phone.required && errors.push("phone Number is required");
       // !this.$v.demo.phone.minLength && errors.push("Minimum 9 and Maximum 15 digit should be allowed in phone number field.");
        !this.$v.phone.maxLength && errors.push("Minimum 9 and Maximum 15 digit should be allowed in phone number field.");

        return errors;
        },
        CompanySizeError() {
            const errors = []
            if (!this.$v.demo.company_size.$dirty) return errors
            !this.$v.demo.company_size.required && errors.push('Company size is required');
            return errors
        },
        CompanyWebsiteError() {
            const errors = []
            if (!this.$v.demo.company_website.$dirty) return errors
            !this.$v.demo.company_website.required && errors.push('Company website is required');
            //!this.$v.demo.company_website.urlvalidate && errors.push('Company website should be valid.');
            return errors
        },
        HeadQuarterError() {
            const errors = []
            if (!this.$v.demo.headQuarter.$dirty) return errors
            !this.$v.demo.headQuarter.required && errors.push('Company Headquarter is required');
            return errors
        },
    },

    mounted() {
        $(this.$refs.slick).slick({
            // Slick options configuration
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                    },
                },
            ],
        });
        this.getCountryList();
    },
    methods: {
        ...mapActions(["genericAPIPOSTRequest"]),
        demoSubmit() {
            this.$v.demo.$touch();
            if(this.phone=='+'+this.phone_code){
                this.Phonemessage='Phone is required';
            }
            this.demo.telephone = this.phone.replace(/\s/g, '');  
            //this.demo.telephone.replace(/\s/g, '');  
            if (!this.$v.demo.$invalid) {
            axios.post(this.$store.state.baseUrl+'addDemo', this.demo).then((response) => {
                if (response.data.status == true) {
                this.demo.first_name="";
                this.demo.last_name="";
                this.demo.company_size=null;
                this.demo.company_website="";
                this.demo.email= "";
                this.demo.telephone= "";
                this.demo.headQuarter= "";
                this.phone='';
                this.phone_code='';
                this.Phonemessage='';
                this.$v.$reset();
                this.$bvModal.show('modal-demo-successful');
                setTimeout(function () {
                    //this.$bvModal.hide('modal-demo-successful');
                    this.$router.push("/").catch(()=>{});
                }.bind(this), 60000)
                    //this.$toastr.s(response.data.message);
                } else {
                    return this.$toastr.e(response.data.message);
                }
            });
            }
        },
        async getCountryList(){
            var country = await this.genericAPIPOSTRequest({
                requestUrl: "common/getCountryList",
                params: {},
              })
              if (country.length > 0 ) {
                  this.country = country;
              }
        },
        isValidHttpUrl() {
            const pattern = new RegExp(
                '^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', // fragment locator
                'i'
            );
            return pattern.test(this.demo.company_website);
        },
        countryChanges(e) {
            this.phone_code = e.dialCode;
        },

    }
};
</script>